export default __webpack_public_path__ + "static/media/afroarte.b5b9d585.jpg";